import { Link } from "react-router";

import { EmptyPage } from "@/assets/images";

type AppProps = {
  title?: string;
  titleSmall?: string;
  text?: string;
  image?: any;
  showAddButton?: boolean;
  imageWidth?: string;
  buttonTitle?: string;
  link?: string;
  linkState?: any;
  client_code?: number;
  company_name?: string;
  onButtonClick?: () => void;
  showLinkButton?: boolean;
};

const EmptyListPage = ({
  title,
  titleSmall,
  text,
  image,
  imageWidth,
  showAddButton,
  showLinkButton,
  buttonTitle,
  link,
  client_code,
  onButtonClick,
  company_name,
}: AppProps) => {
  const finalLink = {
    pathname: link,
    state: { company_name, client_code },
  };

  return (
    <div className="mt-3">
      <h1 className="text-center">{title}</h1>
      {titleSmall && (
        <h3
          className="text-center"
          style={{ fontSize: "18px" }}
        >
          {titleSmall}
        </h3>
      )}
      <div className="text-center">
        <span className="sub-text">{text}</span>
        {showAddButton && (
          <div className="mt-3">
            <button
              onClick={onButtonClick}
              className="btn btn-primary"
            >
              {buttonTitle}
            </button>
          </div>
        )}
        {showLinkButton && (
          <div className="mt-3">
            <Link
              className="btn btn-primary"
              to={finalLink}
              state={finalLink.state}
            >
              {buttonTitle}
            </Link>
          </div>
        )}
        <div className="mt-5">
          <img
            src={image ?? EmptyPage}
            style={{ width: imageWidth }}
          />
        </div>
      </div>
    </div>
  );
};

export default EmptyListPage;
